var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { __ } from "@wordpress/i18n";
import { toast } from "react-toastify";
import { addCustomFieldRequest, markCustomFieldAsDeletedRequest, updateCustomFieldValueRequest, } from "../../api/api";
function useCustomFieldActions() {
    const addCustomField = (entityId, entityType, type, name, description, callback) => __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield addCustomFieldRequest(entityId, entityType, type, name, description);
            if (callback)
                callback(response.data);
        }
        catch (error) {
            console.error(error);
            toast.error(__("Failed to add a custom field", "quicktasker"));
        }
    });
    const markCustomFieldAsDeleted = (customFieldId, callback) => __awaiter(this, void 0, void 0, function* () {
        try {
            yield markCustomFieldAsDeletedRequest(customFieldId);
            if (callback)
                callback();
        }
        catch (error) {
            console.error(error);
            toast.error(__("Failed to mark custom field as deleted", "quicktasker"));
        }
    });
    const updateCustomFieldValue = (customFieldId, value, entityId, entityType, callback) => __awaiter(this, void 0, void 0, function* () {
        try {
            yield updateCustomFieldValueRequest(customFieldId, value, entityId, entityType);
            if (callback)
                callback();
        }
        catch (error) {
            console.error(error);
            toast.error(__("Failed to update custom field value", "quicktasker"));
        }
    });
    return {
        addCustomField,
        markCustomFieldAsDeleted,
        updateCustomFieldValue,
    };
}
export { useCustomFieldActions };
